import { YMaps, Map, Placemark, FullscreenControl } from '@pbe/react-yandex-maps';
import { MediaBreakPoints } from "@/resources/constants";
import { useCurrentWidth } from "@/hooks";

export const MapDirection = () => {
  const windowWidth = useCurrentWidth();

  const breakPointTablet = MediaBreakPoints.TABLET;
  const breakPointMobile = MediaBreakPoints.MOBILE_LARGE

  const defaultState = () => {
    let coordinates = {}

    if (windowWidth <= breakPointMobile) {
      coordinates = { center: [55.57655, 37.42179], zoom: 13 }
    } else if (windowWidth <= breakPointTablet) {
      coordinates = { center: [55.57655, 37.42179], zoom: 13.3 }
    } else {
      coordinates = { center: [55.57655, 37.42179], zoom: 14 }
    }

    return coordinates;
  }

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
    <YMaps>
      <Map
        defaultState={defaultState()}
          width="100%" 
          height="100%"
      >
        <Placemark geometry={[55.570247, 37.410286]} />
        <FullscreenControl />
      </Map>
    </YMaps>
    </div>
  );
};
